/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminPaymentEnumItem
 */
export interface AdminPaymentEnumItem {
    /**
     * 编码
     * @type {number}
     * @memberof AdminPaymentEnumItem
     */
    code?: number;
    /**
     * 枚举标识名
     * @type {string}
     * @memberof AdminPaymentEnumItem
     */
    enumName?: string;
    /**
     * 名称（根据语言环境返回）
     * @type {string}
     * @memberof AdminPaymentEnumItem
     */
    name?: string;
}

/**
 * Check if a given object implements the AdminPaymentEnumItem interface.
 */
export function instanceOfAdminPaymentEnumItem(value: object): value is AdminPaymentEnumItem {
    return true;
}

export function AdminPaymentEnumItemFromJSON(json: any): AdminPaymentEnumItem {
    return AdminPaymentEnumItemFromJSONTyped(json, false);
}

export function AdminPaymentEnumItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminPaymentEnumItem {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'enumName': json['enumName'] == null ? undefined : json['enumName'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function AdminPaymentEnumItemToJSON(json: any): AdminPaymentEnumItem {
    return AdminPaymentEnumItemToJSONTyped(json, false);
}

export function AdminPaymentEnumItemToJSONTyped(value?: AdminPaymentEnumItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'enumName': value['enumName'],
        'name': value['name'],
    };
}

